import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { createResume } from "../../store/actions/resumeActions";

class CreateResume extends Component {
  state = {
    uid: "",
    title: "",
    careerObjectives: "",
    educationalHistory: "",
    languageAbilities: "",
    specialties: "",
    workHistory: ""
  };
  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    console.log(this.state);
    this.props.createResume(this.state);
    this.props.history.push("/");
  };
  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to="/" />;
    // Set the uid of the resume to the authenticated user's uid
    this.state.uid = auth.uid;
    return (
      <div className="container">
        <form onSubmit={this.handleSubmit} className="white">
          <h5 className="page-title">履歴書を作成</h5>
          <div className="input-field">
            <label htmlFor="title">Title</label>
            <input type="text" id="title" onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="careerObjectives">Career Objectives</label>
            <textarea
              id="careerObjectives"
              className="materialize-textarea"
              onChange={this.handleChange}
            />
          </div>
          <div className="input-field">
            <label htmlFor="educationalHistory">Educational History</label>
            <textarea
              id="educationalHistory"
              className="materialize-textarea"
              onChange={this.handleChange}
            />
          </div>
          <div className="input-field">
            <label htmlFor="languageAbilities">Language Abilities</label>
            <textarea
              id="languageAbilities"
              className="materialize-textarea"
              onChange={this.handleChange}
            />
          </div>

          <div className="input-field">
            <button className="btn pink lighten-1 z-depth-0">
              Create Resume
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createResume: resume => dispatch(createResume(resume))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateResume);
